import { filterGroups } from "@/mocks/categories";

interface FilterPanelProps {
  selected: Record<string, string | undefined>;
  onSelect: (key: string, value?: string) => void;
  onReset: () => void;
}

export default function FilterPanel({ selected, onSelect, onReset }: FilterPanelProps) {
  const hasFilter = Object.values(selected).some(Boolean);

  return (
    <div className="bg-background-50 border border-background-200 rounded-lg p-4 md:p-5">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-heading font-bold text-base text-foreground-950 flex items-center gap-2">
          <i className="ri-filter-3-line text-primary-500"></i>
          筛选条件
        </h2>
        {hasFilter && (
          <button
            type="button"
            onClick={onReset}
            className="text-xs text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer flex items-center gap-1"
          >
            <i className="ri-refresh-line"></i>
            重置
          </button>
        )}
      </div>

      <div className="space-y-5">
        {filterGroups.map((group) => (
          <div key={group.key}>
            <p className="text-xs font-label text-foreground-400 mb-2.5 tracking-wide">{group.label}</p>
            <div className="flex flex-wrap gap-2">
              <button
                type="button"
                onClick={() => onSelect(group.key, undefined)}
                className={`px-3 py-1.5 rounded-full text-xs font-label transition-colors cursor-pointer whitespace-nowrap ${
                  !selected[group.key]
                    ? "bg-secondary-700 text-background-50"
                    : "bg-background-100 text-foreground-600 hover:bg-secondary-100"
                }`}
              >
                全部
              </button>
              {group.options.map((opt) => (
                <button
                  key={opt}
                  type="button"
                  onClick={() => onSelect(group.key, opt === selected[group.key] ? undefined : opt)}
                  className={`px-3 py-1.5 rounded-full text-xs font-label transition-colors cursor-pointer whitespace-nowrap ${
                    selected[group.key] === opt
                      ? "bg-primary-500 text-background-50 font-medium"
                      : "bg-background-100 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
                  }`}
                >
                  {opt}
                </button>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}